module.exports = __webpack_public_path__ + "static/media/ico-email.56365305.svg";